module.exports = __webpack_public_path__ + "img/news2-1.fb5c3fca.png";